import { CalendarCheck2 } from "lucide-react";
import { formatDate } from "../data/site";

export default function LastUpdated({ date, dark = false, className = "" }) {
  return (
    <div
      data-testid="last-updated"
      className={`inline-flex items-center gap-2 text-xs font-semibold uppercase tracking-[0.14em] ${
        dark ? "text-stone-400" : "text-stone-500"
      } ${className}`}
    >
      <CalendarCheck2 size={13} className="text-red-500" />
      Last updated: {formatDate(date)}
    </div>
  );
}
